'use client';
import { cn } from "@/lib/utils";
import { ReactNode } from "react";
interface SectionPageLayoutProps {
      id?: string;
      children: ReactNode;
      sectionClassName?: string;
      className?: string;
}

const SectionPageLayout = ({ children, className, sectionClassName, id }: SectionPageLayoutProps) => {
      return <div id={id} className={cn("py-16 md:py-24", sectionClassName)}>
            <div className={cn("container mx-auto p-6 w-full", className)}>
                  {children}
            </div>
      </div>



};

export default SectionPageLayout;


